import Button from "./Button";
import styled from "styled-components/macro";

const SecondaryButton = styled(Button)`
  background: ${(props) => props.theme.colors.secondary};
  border: 1px solid ${(props) => props.theme.colors.primary2};
  color: ${(props) => props.theme.colors.primary2};

  :hover {
    color: white;
  }
`;

export default SecondaryButton;
